/* eslint-disable */
// 自身のログイン状態をチェックする
import {
    //AmazonCognitoIdentity,
    CognitoUserPool //,
    //CognitoUser,
    //AuthenticationDetails 
} from 'amazon-cognito-identity-js'

import { signOut } from "aws-amplify/auth";
// ログイン情報を共通ストアへ記録するため
import { ref } from 'vue'

import axios from 'axios'
import { useRouter, useRoute } from 'vue-router'
const router = useRouter();
const route = useRoute();

const GlobalData = {
    $User_email: null,  // メールアドレス
    user_id: null,      // ユーザID
    user_name:null,     // ユーザー名
    kencd: null,        // 県コード
    city: null,         // 市町村名
    kengen: null,       // 権限
    shakyo_code: null,  // 社協コード
    shokugyo_kbn:null,  // 職業区分（参加条件）
    gakusei_kbn:null,   // 学生区分（参加条件）
    gakunen:null,       // 学年（参加条件）
    $taiken_flow:2, // 体験フロー（申し込みの流れ）
    $ID_Token: {headers: {"Authorization": ""}},    // 認証用IDトークン格納ヘッダー
    $identities : null, // アイデンティティ（ソーシャルログインの場合はこれが入力される）
    enqete_flg : 3, // アンケート回答済みかどうか（0：未回答、1：回答済み、2：回答の必要なし、3：まだ確認できていない）

    $Region:'ap-northeast-1',
    /* 本番環境用 */
    $UserPoolId: 'ap-northeast-1_5exGNrYbn',//ログインユーザープールID（cognito）
    $ClientId: '6q4ktg7bic59n6lks8upoks4bi',//ログインクライアントID（cognito）
    $IdentityPoolId: 'ap-northeast-1:afa16c51-0482-46bb-8f4f-b6d73deb8217',
    $API_URL:'https://www.volukatsu-yell.jp/dev/',//APIのURL 
    $Ninsho_mail:'@volukatsu-yell.jp',
    $CSV_bucket:'volunteer-taiken',//CSVファイル（アンケート・報告書回答）のアップロード先
    $Image_bucket:'volunteer-images',//画像のアップロード先 
    
    /* 本番環境用ここまで */

    /* キテル（開発）環境用 */
     /*
    $UserPoolId: 'ap-northeast-1_6hWWd14Fy',//ログインユーザープールID（cognito）
//    $ClientId: '4sdlml7a8v25nc1ugjvpckk65q',//ログインクライアントID（cognito）
    $ClientId: '1llqmrablorbv31a3riv75iomh',//ログインクライアントID（cognito）
    $IdentityPoolId: 'ap-northeast-1:d026f009-3ac3-4eef-8b41-4da0d048f8de',
    $API_URL:'https://d19ywb8a0wx267.cloudfront.net/dev/',//APIのURL
    $Ninsho_mail:'@kitel.co.jp', 
    $CSV_bucket:'taiken-program',//CSVファイル（アンケート・報告書回答）のアップロード先
    $Image_bucket:'volukatsu-images',//画像アップロード先
    */
    /* キテル（開発）環境用ここまで */

    
    $Address_ken_list:["都道府県",//都道府県名のリスト
        "北海道","青森県","岩手県","宮城県","秋田県","山形県","福島県",
        "茨城県","栃木県","群馬県","埼玉県","千葉県","東京都","神奈川県",
        "新潟県","富山県","石川県","福井県","山梨県","長野県","岐阜県",
        "静岡県","愛知県","三重県","滋賀県","京都府","大阪府","兵庫県",
        "奈良県","和歌山県","鳥取県","島根県","岡山県","広島県","山口県",
        "徳島県","香川県","愛媛県","高知県","福岡県","佐賀県","長崎県",
        "熊本県","大分県","宮崎県","鹿児島県","沖縄県"],

    $Kotsu_list:["",  //交通手段（個人・団体）のリスト（１：自家用車、２：バイク、３：自転車、４：電車／バス、５：徒歩）
                 "自家用車","バイク","自転車","電車／バス","徒歩"],

    $Shokugyo_kbn_list:["",  //職業区分（個人）のリスト（１：学生、２：勤労者、９：その他）
                 "学生","勤労者","","","","","","","その他"],

    $Hoken_plan_list:["",//ボランティア活動保険プラン（個人）のリスト（１：基本、２：天災・地震補償、３：特定感染症重点）
                 "基本","天災・地震補償","特定感染症重点"],

    $Dantai_syurui_list:["",//種類（団体）のリスト（１：社協、２：団体、３：管理団体）
                 "社協","団体","管理団体"],

    $Iraisha_syurui_list:["",//依頼者（ボランティア活動）のリスト（１：個人、２：団体）
                 "個人","団体"],
                      
    $Taisho_list:["",//対象者（ボランティア活動）のリスト（１：身体障碍者、２：知的障碍者、３：精神障碍者、４：高齢、５：徒歩、９：その他）
                    "身体障碍者","知的障碍者","精神障碍者","高齢","児童","","","","その他"],

    // 祝日を取得するAPIを呼び出すためのシークレットキー
    $holiday_key : 'AIzaSyBAyiDQTDocEEfUKIH67I_dKh6LzzOg26k',

    // アンケート未回答時の文言
    $enqete_mikaitou : "体験プログラムの申し込みにはアンケートにご回答いただく必要があります。",
    $enqete_link : "アンケートフォームへ移動する",
    
    // 通信エラー時メッセージ
    $axios_error : "通信エラーが発生しました。画面を再読み込みしてください。",

}

// 各コンポーネント内の<script>タグ内でグローバル変数を参照するための関数
const getUser_email = function() {// ログインユーザーのメールアドレス
    return GlobalData.$User_email
};
let cognitoUser = {}

let login_retry = 0
const login_check = function() {//ログイン状態のチェック

    
	//console.log("$UserPoolId:"+GlobalData.$UserPoolId+"  $ClientId:"+GlobalData.$ClientId);
    let poolData = {
        UserPoolId: GlobalData.$UserPoolId, // Your user pool id here
        ClientId: GlobalData.$ClientId, // Your client id here
    };
    
    let userPool = new CognitoUserPool(poolData);
    cognitoUser = userPool.getCurrentUser();
    
    try{
        // Cognitoセッション情報の取得

            cognitoUser.getSession(function (err, session) {
                if (err) {
                    alert("セッションエラー："+err.message || JSON.stringify(err)+"\n古いログイン情報がブラウザに残っています。恐れ入りますが、ブラウザの「閲覧履歴データの削除」を行ってください。");
                    return
                }
                // 認証用IDトークンの取得およびヘッダーに格納
                GlobalData.$ID_Token = {headers: {"Authorization":session.idToken.jwtToken}};
                GlobalData.$Access_Token = {headers: {"Autorization":session.accessToken.jwtToken}};
            });
        
        cognitoUser.getUserAttributes(function(err, result) {
            if (err) {
                console.log("getUserAttributes："+err.message || JSON.stringify(err));
                return;
            }

            console.log("user value length:"+result.length)
            for (var i = 0; i < result.length; i++) {
                
                console.log(
                    'attribute ' + 'no.' + i + ' ' + result[i].getName() + ' has value ' + result[i].getValue()
                );
                if (result[i].getName() == "email") {
                    GlobalData.$User_email = result[i].getValue()
                    
                }
                if (result[i].getName() == "profile") {
                    GlobalData.$profile = result[i].getValue()
                    let profile = JSON.parse(GlobalData.$profile)
                    GlobalData.user_id = profile.user_id
                    GlobalData.kencd = profile.kencd
                    GlobalData.city = profile.city
                    GlobalData.kengen = profile.kengen
                    GlobalData.shakyo_code = profile.shakyo_code
                    
                    
     
                }

                // ソーシャルログインの場合はこちらが入力される
                if (result[i].getName() == "identities") {
                    GlobalData.$identities = result[i].getValue()
                }
            }


            if(GlobalData.kengen  == "admin" || GlobalData.kengen  == "kanri" || GlobalData.kengen  == "master" ){
                alert("このアカウントでは申込者用画面にログインできません。\n申込者用のアカウントをご利用ください。")    
                logout(GlobalData.shakyo_code)
            }

            // ユーザーIDがある場合はIDを元にユーザー情報を取得            
            if(GlobalData.user_id != null) {
                read_username(GlobalData.user_id)// ユーザー名を取得する
            }else if(GlobalData.$User_email != null){
                
                // IDは無いが、メールアドレスが分かる場合はプロバイダーとメールアドレスで検索
                let providerName = 'mail'
                if(GlobalData.$identities != null){
                    let identities = JSON.parse(GlobalData.$identities)
                    console.log("identities_providerName:"+identities[0]["providerName"])
                    providerName = identities[0]["providerName"]
                }
                read_username_provider(providerName,GlobalData.$User_email)
            }
        });
    } catch (e){
        
        if(login_retry == 5){
            console.log("login NO Good"+e);

        }else{
            login_retry++
            setTimeout(function(){login_check()},"1000")
        }
       
       
    }

}


const read_username = function(id) {//IDからユーザー名を取得
     // 学生区分がnullの場合は取得する
     axios.post(GlobalData.$API_URL + "TaikenUser_read",
        {
            taikenuser_id: id
        },
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {
            //正常な結果が返ってきた場合の処理
            // response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが取得できなかった等）
            // response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する

            if(response.data["status"] == 1){

                console.log("IDによるユーザー名の取得でエラーが発生しました。\n"+response.data["message"])

                // ユーザーが存在しない場合は、プロバイダーとメールアドレスからユーザーを探す
                if(GlobalData.$User_email != null){
                    
                    // IDは無いが、メールアドレスが分かる場合はプロバイダーとメールアドレスで検索
                    let providerName = 'mail'
                    if(GlobalData.$identities != null){
                        let identities = JSON.parse(GlobalData.$identities)
                        console.log("identities_providerName:"+identities[0]["providerName"])
                        providerName = identities[0]["providerName"]
                    }
                    read_username_provider(providerName,GlobalData.$User_email)
                }
            }else{
                // ユーザー名を格納
                GlobalData.user_name = response.data.username
                console.log("ユーザーID取得："+GlobalData.user_name)
                // ログイン情報にプロファイルが存在しない場合
                // Cognitoのprofileを更新
                set_habitat(response.data.taikenuser_id,response.data.address_kencd,response.data.address_shi,'ippan',shakyo_code)
            }
        })
        .catch(error => { 
           // alert("ユーザー名の取得でエラーが発生しました。\n"+error)
        })      
}

const read_username_provider = function(provider,email) {//プロバイダーとメールアドレスからユーザー名を取得
     // 学生区分がnullの場合は取得する
     axios.post(GlobalData.$API_URL + "TaikenUser_read",
        {
            provider: provider,
            email:email
        },
        GlobalData.$ID_Token)//ヘッダーを追加（IDトークンを送信）
        .then(response => {
            //正常な結果が返ってきた場合の処理
            // response.data["status"]・・・status=0の時は正常終了、status=1のときは異常終了（データが取得できなかった等）
            // response.data["message"]・・・API処理結果に付随するメッセージ。主にstatus=1（異常終了）の時に利用する
            if(response.data["status"] == 1){
                console.log("プロバイダーによるユーザー名の取得でエラーが発生しました。\n"+response.data["message"])
            }else{
                // ユーザー情報を格納
                GlobalData.user_name = response.data.username
                GlobalData.user_id = response.data.taikenuser_id
                GlobalData.kencd = response.data.address_kencd
                GlobalData.city = response.data.address_shi
                GlobalData.kengen = 'ippan'
                GlobalData.shakyo_code = response.data.choson_code
                console.log("プロバイダー・メールアドレス取得："+JSON.stringify(GlobalData.user_name))
                // Cognitoのprofileを更新
                set_habitat(response.data.taikenuser_id,response.data.address_kencd,response.data.address_shi,'ippan',shakyo_code)
            }
        })
        .catch(error => { 
            //alert("ユーザー名の取得でエラーが発生しました。\n"+error)
        })      
}


//---------------- ログアウト
async function handleSignOut(cityname) {

    GlobalData.$User_email = null
    GlobalData.user_id = null
    GlobalData.kencd = null
    GlobalData.city = null
    GlobalData.kengen = null
    
    GlobalData.shakyo_code = null

    try {
      await signOut();


    } catch (error) {
     // console.log('error signing out: ', error);
    }
    
    location.href = location.protocol+'//'+location.host+"/"+cityname+'/Taiken'
  }
  

const logout = function(cityname) {

    
    var poolData = {
            UserPoolId : GlobalData.$UserPoolId,
            ClientId : GlobalData.$ClientId
    };
    var userPool = new CognitoUserPool(poolData);
    var cognitoUser = userPool.getCurrentUser();
    if (cognitoUser) {
        // ログアウト
        cognitoUser.signOut();
        GlobalData.$User_email = "";
        //alert("ログアウトしました。");
    }

    GlobalData.$User_email = null
    GlobalData.user_id = null
    GlobalData.kencd = null
    GlobalData.city = null
    GlobalData.kengen = null
    GlobalData.shakyo_code = null

    sessionStorage.removeItem('return_shakyo')
    location.href = location.protocol+'//'+location.host+"/"+cityname+'/Taiken'
}

// 曜日配列
const youbi_list = ["日","月","火","水","木","金","土"]
   //年月日の表示を整える
   let DateSetting = function(changedate){

    if(changedate != null){
        

        let date = Date.parse(changedate);
        let set_date = new Date(date);
        set_date = set_date.toLocaleString("ja-JP", { timeZone: "Europe/London" });
        set_date = new Date(set_date);

        return (set_date.getMonth()+1)+"月"+set_date.getDate()+"日("+youbi_list[set_date.getDay()]+")";
    }else{
        return
    }
 }
 //時間の表示を整える
 let TimeSetting = function(changetime){
  if(changetime != null){
      
      return changetime.slice( 0, 5 );
  }else{
      return ""
  }

 }
 //年月日＋時間の表示を整える
 let DateTimeSetting = function(changedate){
    let date = Date.parse(changedate);
    let set_date = new Date(date);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
    set_date.setHours(set_date.getHours());

    //return date;
    return (set_date.getMonth()+1)+"月"+set_date.getDate()+"日("+youbi_list[set_date.getDay()]+") "+ ('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2)
 }

 //年月日＋時間の表示を整える(EU時間)
 let EuDateTimeSetting = function(changedate){
    /*
    let date = Date.parse(changedate);
    let set_date = new Date(date);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
    set_date.setHours(set_date.getHours()-8);
*/

    let eudate = Date.parse(changedate);
    let eu_set_date = new Date(eudate);
    eu_set_date = eu_set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    eu_set_date = new Date(eu_set_date);
    eu_set_date.setHours(eu_set_date.getHours()-9);

    const set_month = eu_set_date.getMonth()+1

    // 日時から日と時をそれぞれ抜き出す
    let day = (eu_set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+eu_set_date.getDate()).slice(-2)
    let time = ('00'+eu_set_date.getHours()).slice(-2)+":"+('00'+eu_set_date.getMinutes()).slice(-2);

    let return_date = new Date(day + " "+time)
    return_date = return_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    return_date = new Date(return_date);
    return (return_date.getMonth()+1)+"月"+return_date.getDate()+"日("+youbi_list[return_date.getDay()]+") "+ ('00'+return_date.getHours()).slice(-2)+":"+('00'+return_date.getMinutes()).slice(-2)
 }

 //〆切日を整える
 let ShimekiriSetting = function(changedate){
    let date = Date.parse(changedate);
    let set_date = new Date(date);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
    set_date.setHours(set_date.getHours());

    //return date;
    return set_date
 }

 //〆切日を整える(EU時間)
 let EuShimekiriSetting = function(changedate){

    let eudate = Date.parse(changedate);
    let eu_set_date = new Date(eudate);
    eu_set_date = eu_set_date.toLocaleString("ja-JP", { timeZone: "Europe/London" });
    eu_set_date = new Date(eu_set_date);
    eu_set_date.setHours(eu_set_date.getHours());
    
    const set_month = eu_set_date.getMonth()+1
    
    // 日時から日と時をそれぞれ抜き出す
    let day = (eu_set_date.getFullYear())+"-"+('00'+set_month).slice(-2)+"-"+('00'+eu_set_date.getDate()).slice(-2)
    let time = ('00'+eu_set_date.getHours()).slice(-2)+":"+('00'+eu_set_date.getMinutes()).slice(-2);

    let return_date = new Date(day + " "+time)
    return_date = return_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    return_date = new Date(return_date);

    return return_date
    /*
    
    let date = Date.parse(changedate);
    let set_date = new Date(date);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_date = new Date(set_date);
    set_date.setHours(set_date.getHours()-8);
    */

    //return set_date;
 }
 

 //公開日を整える
 let Kokai_setting = function(set_date,set_hour){
    
    
    let kokai_date = new Date(set_date + " "+set_hour)
    kokai_date = kokai_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    kokai_date = new Date(kokai_date);
    return kokai_date
 }

 // 開催日を整える
let Kaisai_setting = function(chengedate){

    let kaisai_date = Date.parse(chengedate);
    let set_kaisai_date = new Date(kaisai_date);
    set_kaisai_date = set_kaisai_date.toLocaleString("ja-JP", { timeZone: "Asia/Tokyo" });
    set_kaisai_date = new Date(set_kaisai_date);
    return set_kaisai_date.getFullYear()+"-"+(set_kaisai_date.getMonth()+1)+"-"+set_kaisai_date.getDate()

}

const Search_timestamp = function(timestamp){// 各検索の「更新日時」の計算
    let date = Date.parse(timestamp);
    let set_date = new Date(date);
    set_date = set_date.toLocaleString("ja-JP", { timeZone: "Europe/London" });
    set_date = new Date(set_date);
    set_date.setHours(set_date.getHours());
    //return date;
    return set_date.getFullYear()+"-"+('00'+(set_date.getMonth()+1)).slice(-2)+"-"+('00'+set_date.getDate()).slice(-2)+" "+('00'+set_date.getHours()).slice(-2)+":"+('00'+set_date.getMinutes()).slice(-2);
}


  let youbi_irekae = function(set_youbi){
    
    if(set_youbi != null){
        set_youbi = set_youbi.replace(/､/g, '、')
        
        let set_array = set_youbi.split("、")

        const syuku_youbi_list = ["日","月","火","水","木","金","土","祝"]
        let disp_youbi_list = []

        let set_list = ""
        // 日・祝以外を取得
        for(let s = 0;s<set_array.length;s++){
            for(let l = 0;l<syuku_youbi_list.length;l++){
                if(set_array[s] == syuku_youbi_list[l]){
                    if(syuku_youbi_list[l] != "日" && syuku_youbi_list[l] != "祝" ){
                        disp_youbi_list[disp_youbi_list.length] = syuku_youbi_list[l]
                    }
                }
            }
        }
        // 日を取得
        for(let s = 0;s<set_array.length;s++){
            for(let l = 0;l<syuku_youbi_list.length;l++){
                if(set_array[s] == syuku_youbi_list[l]){
                    if(syuku_youbi_list[l] == "日" ){
                        disp_youbi_list[disp_youbi_list.length] = syuku_youbi_list[l]
                    }
                }
            }
        }
        // 祝を取得
        for(let s = 0;s<set_array.length;s++){
            for(let l = 0;l<syuku_youbi_list.length;l++){
                if(set_array[s] == syuku_youbi_list[l] || set_array[s] == "祝日"){
                    if( syuku_youbi_list[l] == "祝" ){
                        disp_youbi_list[disp_youbi_list.length] = syuku_youbi_list[l]
                    }
                }
            }
        }

        // 重複を削除
        disp_youbi_list = Array.from(new Set(disp_youbi_list));
        for(let d = 0;d<disp_youbi_list.length;d++){
            
            if(set_list != "") set_list += "、"
            set_list += disp_youbi_list[d]
        }

        return set_list
    }
  }

// 一般ユーザーの追加
let error_count = 0;
const set_habitat = (user_id,kencd,city,kengen,shakyo_code) => {
    let poolData = {
        UserPoolId: GlobalData.$UserPoolId, // Your user pool id here
        ClientId: GlobalData.$ClientId, // Your client id here
    };
    
    let userPool = new CognitoUserPool(poolData);
    cognitoUser = userPool.getCurrentUser();

    try{
        // Cognitoセッション情報の取得

            cognitoUser.getSession(function (err, session) {
                if (err) {
                    console.log("セッションエラー："+err.message || JSON.stringify(err)+"\n古いログイン情報がブラウザに残っています。恐れ入りますが、ブラウザの「閲覧履歴データの削除」を行ってください。");
                    return
                }
                // 認証用IDトークンの取得およびヘッダーに格納
                GlobalData.$ID_Token = {headers: {"Authorization":session.idToken.jwtToken}};
                GlobalData.$Access_Token = {headers: {"Autorization":session.accessToken.jwtToken}};
            });
            let attributeList = [
                {
                    Name: 'profile',
                    Value: '{"user_id":'+user_id+',"kencd":"'+kencd+'","city":"'+city+'","kengen":"'+kengen+'","shakyo_code":"'+shakyo_code+'"}'
                } 
            ]
            cognitoUser.updateAttributes(attributeList,
                function(err, result) {
                if (err) {
                    alert(err.message || JSON.stringify(err));
                    return;
                }
                console.log("updateAttribute result:"+result)
               // login_check()
            });
    
    } catch (e){
        
        if(error_count == 6){
           // alert("ログイン情報の取得に失敗しました。一度「マイページ」の「設定」からログアウトして、もう一度ログインしてください。"+e);
        }else{
            error_count++
            setTimeout(function(){set_habitat(user_id,kencd,city,kengen,shakyo_code)},"1000")
        }
       
    }
}
export { GlobalData, getUser_email, login_check, logout,handleSignOut, Search_timestamp, set_habitat,DateSetting,TimeSetting,DateTimeSetting,ShimekiriSetting,EuDateTimeSetting,EuShimekiriSetting,Kokai_setting,Kaisai_setting,youbi_irekae }
